import React from 'react'
import styles from '../../styles.module.css'


const fmt = (v) => (v === null || v === undefined || v === '') ? '—' : v

const TOTAL_COLS = 16

const GROUPS = [
  { key: 'total',      label: 'Всего работников',            staff: 'totalStaff',      list: 'totalList',      reserve: 'reserveOfficersTotal' },
  { key: 'leadership', label: 'Руководящий состав',          staff: 'leadershipStaff', list: 'leadershipList', reserve: 'reserveOfficersLeadership' },
  { key: 'admin',      label: 'Административный персонал',   staff: 'adminStaff',      list: 'adminList',      reserve: 'reserveOfficersAdmin' },
  { key: 'support',    label: 'Учебно-вспомогательный персонал', staff: 'supportStaff', list: 'supportList',   reserve: 'reserveOfficersSupport' },
]

const EXPERIENCE = [
  { key: 'lt3',  label: 'До 3 лет',     field: 'experienceLessThan3' },
  { key: 'lt10', label: 'До 10 лет',    field: 'experienceLessThan10' },
  { key: 'lt20', label: 'До 20 лет',    field: 'experienceLessThan20' },
  { key: 'gt20', label: 'Более 20 лет', field: 'experienceGreaterThanOrEq20' },
]


const StaffingTable = ({ row }) => {
  return (
    <table className={styles.mainTable}>
      <thead>
        <tr className={styles.titleRow}>
          <th className={styles.titleLeft} colSpan={TOTAL_COLS - 1}>Сведения о работниках</th>
          <th className={styles.titleRight}>Форма №3/СВУ</th>
        </tr>
        <tr className={`${styles.titleRow} ${styles.secondTitleRow}`}>
          <th className={styles.titleLeft} colSpan={TOTAL_COLS - 1}>{row.organizationName}</th>
          <th className={styles.titleRight}>Таблица №1</th>
        </tr>
        <tr>
          {GROUPS.map(g => <th key={g.key} colSpan={3}>{g.label}</th>)}
          <th colSpan={4}>Стаж работы</th>
        </tr>
        <tr>
          {GROUPS.map(g => (
            <React.Fragment key={g.key}>
              <th className={styles.vertical}>По штату</th>
              <th className={styles.vertical}>По списку</th>
              <th className={styles.vertical}>Количество офицеров запаса</th>
            </React.Fragment>
          ))}
          {EXPERIENCE.map(e => <th key={e.key} className={styles.vertical}>{e.label}</th>)}
        </tr>
      </thead>
      <tbody>
        <tr>
          {GROUPS.map(g => (
            <React.Fragment key={g.key}>
              <td>{fmt(row[g.staff])}</td>
              <td>{fmt(row[g.list])}</td>
              <td>{fmt(row[g.reserve])}</td>
            </React.Fragment>
          ))}
          {EXPERIENCE.map(e => <td key={e.key}>{fmt(row[e.field])}</td>)}
        </tr>
      </tbody>
    </table>
  )
}

export default StaffingTable
